<script setup lang="ts">
import { computed, useAttrs } from 'vue'

const props = defineProps<{
  modelValue?: string | number
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'update:model-value', value: string): void
  (e: 'blur', event: FocusEvent): void
  (e: 'keydown', event: KeyboardEvent): void
}>()

const attrs = useAttrs()

const value = computed(() => String(props.modelValue ?? ''))

function onInput(event: Event) {
  const nextValue = (event.target as HTMLInputElement).value
  emit('update:modelValue', nextValue)
  emit('update:model-value', nextValue)
}
</script>

<template>
  <input
    v-bind="attrs"
    class="input-log"
    :value="value"
    @input="onInput"
    @blur="emit('blur', $event)"
    @keydown="emit('keydown', $event)"
  />
</template>
